export default "/images/vendor/flag-icon-css/flags/4x3/gr.svg?e2d0116790bdfda46fb4cdedc74b5b53";